import { HttpClient } from '@angular/common/http';
import { INDRAApiService } from './api.indra.service';
import { URL_VALIDATE_PROMO_CODE, URL_VALIDATE_VOUCHER, URL_PARTIAL_VOUCHER, MOCK_STATUS, MOCK_URL_PROMOCODE_OK, URL_VOUCHER_IN_SESSION, URL_PROMOCODE_IN_SESSION, URL_REMOVE_PROMOCODE_IN_SESSION, URL_REMOVE_VOUCHER_IN_SESSION, DISCOUNT_TYPE_VOUCHER, DISCOUNT_TYPE_PROMOCODE, MOCK_URL_VALIDATE_VOUCHER_CODE_OK, URL_VALIDATE_VOUCHER_CODE } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
var INDRADiscountService = /** @class */ (function () {
    function INDRADiscountService(http, api) {
        this.http = http;
        this.api = api;
    }
    INDRADiscountService.prototype.validateVoucherPromoCode = function (code, type, bookAwards) {
        if (MOCK_STATUS.PROMOCODE_VOUCHER) {
            // return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_OK);
            // return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_ERROR);
            // return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_NOT_FOUND);
            return this.api.INDRA_get(MOCK_URL_PROMOCODE_OK);
        }
        else {
            if (type === DISCOUNT_TYPE_VOUCHER) {
                return this.api.INDRA_post(URL_VALIDATE_VOUCHER, code);
            }
            else if (type === DISCOUNT_TYPE_PROMOCODE) {
                var params = {
                    'payWithMiles': bookAwards,
                    'promocode': code
                };
                return this.api.INDRA_post("" + URL_VALIDATE_PROMO_CODE, params);
            }
        }
    };
    INDRADiscountService.prototype.INDRA_validateVoucherPin = function (voucher, email, mfaCode) {
        if (MOCK_STATUS.VOUCHER_CODE) {
            // return this.api.INDRA_get<any>(MOCK_URL_VALIDATE_VOUCHER_CODE_NOK);
            return this.api.INDRA_get(MOCK_URL_VALIDATE_VOUCHER_CODE_OK);
        }
        else {
            var params = {
                'voucher': voucher,
                'email': email,
                'mfaCode': mfaCode
            };
            return this.api.INDRA_post(URL_VALIDATE_VOUCHER_CODE, params);
        }
    };
    INDRADiscountService.prototype.INDRA_getVouchersInSession = function () {
        return this.api.INDRA_get("" + URL_VOUCHER_IN_SESSION);
    };
    INDRADiscountService.prototype.INDRA_getPromocodesInSession = function () {
        return this.api.INDRA_get("" + URL_PROMOCODE_IN_SESSION);
    };
    INDRADiscountService.prototype.INDRA_removePromoCodeInSession = function (code) {
        return this.api.INDRA_get(URL_REMOVE_PROMOCODE_IN_SESSION + "/" + code);
    };
    INDRADiscountService.prototype.INDRA_removeVoucherInSession = function (code) {
        return this.api.INDRA_get(URL_REMOVE_VOUCHER_IN_SESSION + "/" + code);
    };
    INDRADiscountService.prototype.INDRA_sendVoucherAmount = function (amount) {
        return this.api.INDRA_post("" + URL_PARTIAL_VOUCHER, amount);
    };
    INDRADiscountService.ngInjectableDef = i0.defineInjectable({ factory: function INDRADiscountService_Factory() { return new INDRADiscountService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService)); }, token: INDRADiscountService, providedIn: "root" });
    return INDRADiscountService;
}());
export { INDRADiscountService };
